const NEW_NOTIFICATIONS = (state, data) => {
  state.newNotifications = data
}

const ACTIVE_NOTIFICATIONS = (state, data) => {
  state.activeNotifications = data
}

const RECENT_NOTIFICATIONS = (state, data) => {
  state.recentNotifications = data
}

const SHOW_NOTIFICATION_BAR = (state, data) => {
  state.showNotificationBar = data
}

export default {
  NEW_NOTIFICATIONS,
  ACTIVE_NOTIFICATIONS,
  RECENT_NOTIFICATIONS,
  SHOW_NOTIFICATION_BAR
}
